import useRouter from 'src/shared/hooks/useRouter';

const useMode = () => {
    const router = useRouter();

    const { mode } = router.query;

    const isMobile = mode === 'mobile';

    return { isMobile };
};

export default useMode;
